import { getOne } from "../../Provider";

export function GetBusinessPartnerInfoService(id) {
  return getOne(id);
}